import * as Sentry from '@sentry/browser';

let sentryIsInitialized = false;

const init = (dsn) => {
  Sentry.init({
    dsn,
  });
  sentryIsInitialized = true;
};
const isInit = () => sentryIsInitialized;
const getInstance = () => Sentry;

const setUserId = (id) => {
  if (id) {
    Sentry.setUser({ id });
    // eslint-disable-next-line no-console
    console.info(`Sentry set user ID: ${id}`);
  }
};

const captureException = (error, additionalInfo) => {
  if (!sentryIsInitialized) return;

  Sentry.withScope((scope) => {
    const { request, response } = error;
    scope.setExtras({
      ...(additionalInfo && { additionalInfo }),
      ...(request && { request: JSON.stringify(request) }),
      ...(response && { response: JSON.stringify(response) }),
    });
    Sentry.captureException(error);
  });
};

export default {
  init,
  getInstance,
  isInit,
  setUserId,
  captureException,
};
